export const trimAll = (str: string) => str.trim().replace(/\s+/g, ' ')

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.toLowerCase().slice(1)

export const capitalizeAll = (str: string) => trimAll(str).replace(/\w\S*/g, capitalize)
